var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"widget",class:[_vm.$attrs.standalone ? 'alternativ-standalone' : 'plan-widget']},[(_vm.url && _vm.active)?_c('PDFViewer',{attrs:{"url":_vm.url,"hasFunnel":_vm.hasFunnel}}):_vm._e(),_vm._v(" "),(_vm.hasFunnel)?_c('FunnelFooter'):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ca9827dc","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/PlanWidget.vue
// module id = null
// module chunks = 